// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__caWGx","footer-links":"footer_footer-links__MauAU"};